import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { forgotPassword } from '../../services/authService'
import { apiError } from '../../../admin/api/apiError'
import AuthCard from '../../components/AuthCard/AuthCard'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function ForgotPasswordPage() {
  const { t } = useTranslation()

  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!EMAIL_RE.test(email.trim())) {
      setError(t('dealer.forgot.error_email'))
      return
    }
    setError('')
    setLoading(true)
    try {
      await forgotPassword(email.trim())
      setSent(true)
    } catch (err) {
      // бэк не раскрывает наличие email: любой ответ 4xx считаем «отправлено»,
      // ошибку показываем только при сбое сети или сервера
      const { status } = apiError(err)
      if (status && status < 500) setSent(true)
      else setError(t(status ? 'dealer.common.error_server' : 'dealer.common.error_network'))
      console.error('[ERROR] Dealer forgot-password failed:', err)
    } finally {
      setLoading(false)
    }
  }

  const footer = (
    <Link to="/login" className="dealer-link">{t('dealer.common.back_to_login')}</Link>
  )

  if (sent) {
    return (
      <AuthCard title={t('dealer.forgot.sent_title')} footer={footer}>
        <div className="dealer-alert dealer-alert--success">
          {t('dealer.forgot.sent_text', { email: email.trim() })}
        </div>
        <p className="dealer-hint">{t('dealer.forgot.sent_hint')}</p>
      </AuthCard>
    )
  }

  return (
    <AuthCard title={t('dealer.forgot.title')} subtitle={t('dealer.forgot.subtitle')} footer={footer}>
      <form className="dealer-auth__form" onSubmit={handleSubmit} noValidate>
        <div className="dealer-field">
          <label className="dealer-label" htmlFor="dealer-forgot-email">{t('dealer.forgot.label_email')}</label>
          <input
            id="dealer-forgot-email"
            className={`dealer-input${error ? ' dealer-input--error' : ''}`}
            type="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError('') }}
            autoFocus
            autoComplete="email"
            inputMode="email"
            disabled={loading}
          />
        </div>

        {error && <div className="dealer-alert dealer-alert--error" role="alert">{error}</div>}

        <button className="dealer-btn dealer-btn--primary dealer-btn--block" type="submit" disabled={loading}>
          {loading ? t('dealer.forgot.sending') : t('dealer.forgot.submit')}
        </button>
      </form>
    </AuthCard>
  )
}
